<section class="container-fluid temp-color" xmlns="http://www.w3.org/1999/html">
  <div class="row">
    <div class="col-sm-12 padding-left">
      <print-sponsor-doc></print-sponsor-doc>
    </div>
  </div>
</section>
